import { html, ref, when } from '@microsoft/fast-element';
import { plusIcon, pencilIcon } from '../../styles';
import type { SellerDashboard } from './seller-dashboard';
import { eventDetail } from '../../utils/formatting';
import { hasPermission } from '../../utils/profiles';
import { PROFILE_RIGHTS } from '../../utils';

export const SellerDashboardTemplate = html<SellerDashboard>`
  <div class="cascade-route-content">
    <div class="seller-dashboard">
      <zero-card>
        <seller-tile class="seller-tile" ${ref('tileElement')} :project=${(x) => x.selectedProject}>
          ${when(
            (x) => x.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.UPSERT_PROJECT),
            html<SellerDashboard>`
              <zero-button
                class="edit-project"
                appearance="card-secondary"
                slot="buttons"
                @click="${(x) => x.editProject()}"
              >
                ${pencilIcon('start')} Edit Project
              </zero-button>
            `,
          )}
        </seller-tile>
      </zero-card>

      <zero-card class="no-padding-card">
        <vppa-management
          @openModal="${(x, c) => x.openVppaModal()}"
          :project=${(x) => x.selectedProject}
          :hasProject=${(x) => x.hasProject}
          :projectsListEmpty=${(x) => x.projectsListEmpty}
          @editVppa="${(x, c) => x.editVppa(eventDetail(c))}"
          @copyVppa="${(x, c) => x.copyVppa(eventDetail(c))}"
          @deleteVppa="${(x, c) => x.deleteVppa(eventDetail(c))}"
          @reviewProposal="${(x, c) => x.reviewProposal(eventDetail(c))}"
          @clearRejected="${(x, c) => x.clearRejected(eventDetail(c))}"
          @reviewAndClearRejected="${(x, c) => x.reviewAndClearRejected(eventDetail(c))}"
          @goToArteria="${(x, c) => x.goToArteriaPage(eventDetail(c))}"
          @goToExecution="${(x, c) => x.goToExecutionPage(eventDetail(c))}"
          @vppaRowSelected=${(x, c) => x.getCurrentVppa(eventDetail(c))}
          @goToArteriaNegotiationsPage="${(x, c) => x.goToArteriaNegotiationsPage(eventDetail(c))}"
          @openMoreInfoModal="${(x, c) => x.openMoreInfoModal(eventDetail(c))}"
        ></vppa-management>
      </zero-card>

      <zero-card>
        <h3 class="market-index-title">
          Market Index Performance
          ${(x) => (x.selectedVppa?.TICKER ? x.selectedVppa.TICKER + '-' : '')}${(x) =>
            x.selectedVppa?.UNIQUE_ID}
        </h3>
        <market-performance-graph
          :vppaId=${(x) => x.selectedVppa?.VPPA_ID}
        ></market-performance-graph>
      </zero-card>

      <zero-card
        class="projects-card no-padding-card"
        style="display: ${(x) =>
          hasPermission(x.userService.getFilteredPermissions(), PROFILE_RIGHTS.SELLER_VISIBILITY)
            ? ''
            : 'none'}"
      >
        <my-projects-container
          ${ref('myProjectsElement')}
          @listProjects="${(x, c) => x.setProjectList(eventDetail(c))}"
          @hasProjectEvent="${(x, c) => x.hasProjectSet(eventDetail(c))}"
          @projectSelected="${(x, c) => x.changeSelectedProject(eventDetail(c))}"
          @draftProjectSelected="${(x, c) => x.openDraftProjectModal(eventDetail(c))}"
          @vppaRowSelected="${(x, c) => x.getCurrentVppa(eventDetail(c))}"
          @noProjects="${(x, c) => x.isProjectListEmpty(eventDetail(c))}"
        >
          ${when(
            (x) => x.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.UPSERT_PROJECT),
            html<SellerDashboard>`
              <zero-button
                slot="buttons"
                @click=${(x) => x.createProject()}
                appearance="card-primary"
              >
                ${plusIcon('start')} New Project
              </zero-button>
            `,
          )}
        </my-projects-container>
      </zero-card>
    </div>

    <project-modal ${ref('projectModal')}></project-modal>
    <more-info-modal ${ref('moreInfoModal')}></more-info-modal>

    <vppa-modal ${ref('vppaModal')}></vppa-modal>

    <cancel-modal
      ${ref('cancelModal')}
      @confirmCancel="${(x, c) => x.cancelVppa(eventDetail(c))}"
    ></cancel-modal>
  </div>
`;
